<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div
        class="item van-hairline--bottom"
        @click="changeLang('en', $event)"
      >
        <div class="flex_center">
          <div class="info">English</div>
        </div>
        <div v-if="lang == 'en'">✓</div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { Toast } from 'vant';
import { getCurrentLang, setCurrentLang, syncLangWithBackend, getCurrentFullLang } from '../../common/lang';

export default {
  name: 'Language',
  data() {
    return {
      lang: getCurrentLang(), // 短代码用于显示和比较
      source: '',
    };
  },
  created() {
    // 初始化时同步当前语言到后端
    const currentFullLang = getCurrentFullLang();
    syncLangWithBackend(this.$http, currentFullLang);
  },
  mounted() {
    this.source = this.$route.params.type;
    // 确保 i18n locale 与 localStorage 同步
    const currentFullLang = getCurrentFullLang();
    if (this.$i18n.locale !== currentFullLang) {
      this.$i18n.locale = currentFullLang;
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    changeLang(lang) {
      // 设置语言并获取完整代码
      const fullLang = setCurrentLang(lang);
      
      // 更新本地状态（使用短代码用于显示）
      this.lang = lang;
      
      // 更新 i18n locale（使用完整代码）
      this.$i18n.locale = fullLang;
      
      // 同步到后端
      syncLangWithBackend(this.$http, fullLang);
      
      // 显示成功提示
      Toast.success({
        message: this.$t('setting.language') + ' ' + this.$t('reservation.refresh'),
        duration: 1000
      });
      
      // 延迟一下让用户看到切换效果，然后跳转
      setTimeout(() => {
        if (this.source === 'setting') {
          this.$router.push({ path: '/Home' });
        } else {
          this.$router.go(-1);
        }
      }, 500);
    },
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.nav-bar {
  background: #D63793 !important;
}
::v-deep .van-nav-bar {
  background: #D63793 !important;
}
::v-deep .van-nav-bar__title {
  color: #fff !important;
}
.container .items {
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding:  25px;
}
.container .items .item {
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}
.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
  padding: 10px 0;
}
.container .sign-out {
  margin: 500px 20px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}
.container .item .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
.container .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_center {
  display: flex;
  align-items: center;
}
.flex_center img {
  width: 60px;
  height: 60px;
  margin-right: 20px;
}
</style>
